// Card size picker: "+" toggle for touch devices.
// Uses document-level delegation so cards added later (filters, infinite scroll, AJAX sections) work without re-init.
(() => {
  if (window.__cardSizesInit) return;
  window.__cardSizesInit = true;

  const OPEN = 'is-open';

  const setOpen = (root, open) => {
    root.classList.toggle(OPEN, open);
    const toggle = root.querySelector('[data-card-sizes-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
  };

  const closeAll = (except) => {
    document.querySelectorAll(`[data-card-sizes].${OPEN}`).forEach((el) => {
      if (el !== except) setOpen(el, false);
    });
  };

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-card-sizes-toggle]');
    if (toggle) {
      e.preventDefault();
      const root = toggle.closest('[data-card-sizes]');
      const willOpen = !root.classList.contains(OPEN);
      closeAll(root);
      setOpen(root, willOpen);
      return;
    }
    // Tap anywhere outside an open picker closes it
    if (!e.target.closest('[data-card-sizes]')) closeAll();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
})();